// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drilldown-modal {
    background: #ffffff;
    border: 1px solid #ddd;
    padding: 1.25rem;
    margin-top: 1.5rem;
    border-left: 5px solid #0061b0;
    border-radius: 10px;
}

    .drilldown-modal h3 {
        margin-top: 0;
        color: #333;
    }

    .drilldown-modal p {
        font-size: 0.95rem;
        margin-bottom: 0.75rem;
    }

    .drilldown-modal button {
        padding: 6px 12px;
        background: #0061b0;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
    }
`, "",{"version":3,"sources":["webpack://./src/components/AI/DrillDownModal.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;AACvB;;IAEI;QACI,aAAa;QACb,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,eAAe;IACnB","sourcesContent":[".drilldown-modal {\n    background: #ffffff;\n    border: 1px solid #ddd;\n    padding: 1.25rem;\n    margin-top: 1.5rem;\n    border-left: 5px solid #0061b0;\n    border-radius: 10px;\n}\n\n    .drilldown-modal h3 {\n        margin-top: 0;\n        color: #333;\n    }\n\n    .drilldown-modal p {\n        font-size: 0.95rem;\n        margin-bottom: 0.75rem;\n    }\n\n    .drilldown-modal button {\n        padding: 6px 12px;\n        background: #0061b0;\n        color: white;\n        border: none;\n        border-radius: 4px;\n        cursor: pointer;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
